import * as Constants from "../../common/constants";
import { IPagination } from ".";
import { BaseListing } from "../listing-base-model";
export class ApiResponse<TResult = any> {
  isSuccess?: boolean;
  data?: string | TResult | TResult[] | null;
  message?: string;
  code?: number;
  extendData?: any;
  errorCode?: number

  /**
   *
   */
  constructor(options: ApiResponse, header?: any) {
    if (options === null) options = { isSuccess: false };

    this.isSuccess = options.isSuccess;
    this.message = options.message;
    this.code = options.code;
    this.extendData = options.extendData;
    this.errorCode = options.errorCode

    if (
      header !== undefined &&
      header[Constants.X_PAGINATION_PAGE_COUNT] !== undefined
    ) {
      delete options.data.Pagination;
      this.data = new BaseListing({
        ...options.data,
        Pagination: <IPagination>{
          pagecount: parseInt(header[Constants.X_PAGINATION_PAGE_COUNT]),
          pagesize: parseInt(header[Constants.X_PAGINATION_PAGE_SIZE]),
          pageindex: parseInt(header[Constants.X_PAGINATION_PAGE_INDEX]),
          total: parseInt(header[Constants.X_PAGINATION_TOTAL])
        }
      }) as any;
    } else this.data = options.data || null;
  }
}
